export const InitialSelfEnrolmentState = {
  sendingVerificationCode: false,
  verificationCodeSentSuccessfully: false,
  verificationCodeSentFailed: false,
  email: "",
  verificationCode: "",
  gettingSelfEnrolmentUserData: false,
  getSelfEnrolmentUserDataSuccess: false,
  getSelfEnrolmentUserDataFailed: false,
  userData: {},
  selectedCompanyGuid: "",
  gettingSelfEnrolmentCompanyData: false,
  getSelfEnrolmentCompanyDataSuccess: false,
  getSelfEnrolmentCompanyDataFailed: false,
  companyData: {},
  routeData: {},
  businessLegalName: "",
  enrolmentStatus: "",
  submitSelfEnrolmentCompanyDataSuccess: false,
  selfEnroledCompanies: [],
  companySelfEnrolmentDeclined: false,
  companySelfEnrolmentDeclineFailed: false,
  companySelfEnrolmentApproved: false,
  companySelfEnrolmentApprovalFailed: false,
  updatedOn: "",
};
